import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCloudUpload = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 33,
	height: 32,
	viewBox: "0 0 33 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M17.8334 25.3334V20H21.8334L16.5 13.3334L11.1667 20H15.1667V25.3334H17.8334Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9.83335 25.3333H12.5V22.6666H9.83335C7.62802 22.6666 5.83335 20.872 5.83335 18.6666C5.83335 16.7946 7.43202 14.992 9.39735 14.6466L10.172 14.5106L10.428 13.7666C11.3654 11.032 13.6934 9.33329 16.5 9.33329C20.176 9.33329 23.1667 12.324 23.1667 16V17.3333H24.5C25.9707 17.3333 27.1667 18.5293 27.1667 20C27.1667 21.4706 25.9707 22.6666 24.5 22.6666H20.5V25.3333H24.5C27.4414 25.3333 29.8334 22.9413 29.8334 20C29.8313 18.8048 29.4289 17.6447 28.6903 16.7051C27.9517 15.7654 26.9196 15.1003 25.7587 14.816C25.176 10.2266 21.2467 6.66663 16.5 6.66663C12.8254 6.66663 9.63335 8.81463 8.17602 12.2C5.31202 13.056 3.16669 15.76 3.16669 18.6666C3.16669 22.3426 6.15735 25.3333 9.83335 25.3333Z",
		fill: "currentColor"
	})]
});
export default SvgCloudUpload;
